import client from 'api/client';

export const fetchPeaks = ({collectionId, peaksUrl, locale}) =>
  client().get(peaksUrl || `/collections/v2/${collectionId}/peaks`, {locale});

export const generatePeaks = ({collectionId}) =>
  client().post(`pipeline/collection/${collectionId}/peaks`);
